import {
  CameraConnectionIssueReason,
  captureCameraEvent,
  EXAM_EVENTS,
} from 'src/services/posthogEvents';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

export function reportCameraConnectionIssue(
  reason: CameraConnectionIssueReason,
): void {
  const { setCameraConnectionIssueReason } = useRemoteBoundStore.getState();

  setCameraConnectionIssueReason(reason);
  captureCameraEvent(EXAM_EVENTS.CAMERA_CONNECTION_ISSUE, { reason });
}
